import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/unitDeleteForm.jst.html';

/**
 * defa.views.UnitDeleteForm
 * A card for deleting Units
 * @version 1.2.0
 */

const UnitDeleteForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		if ( defa.vars.android ) {
			window.android.removeBLEUnit( this.model.get( 'id' ) );
		}
		
		if ( defa.vars.webkit ) {
			window.webkit.messageHandlers.removeBLEUnit.postMessage( this.model.get( 'id' ) );
		}
	},
} );


export default UnitDeleteForm;